<template>
  <head>
    <title>
      {{ $t("Services") }}
    </title>
  </head>
  <div class="products-view">
    <AdminSidebar>
      <TableComponent
        :titles="titles"
        :data="data"
        :title="title"
        :pageUrl="pageUrl"
        deleteApi="api/delete_product"
        EditUrl="/update-product"
      />
    </AdminSidebar>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import AdminSidebar from "@/components/AdminDashboard/AdminSidebar.vue";
import TableComponent from "@/components/AdminDashboard/TableComponent.vue";

export default {
  name: "products-view",
  data() {
    return {
      data: {},
      ErrorMessage: "",
      titles: [
        "id",
        "name_en",
        "name_ar",
        "description_en",
        "description_ar",
        "delete",
        "update",
        "show",
      ],
      title: "Services",
      pageUrl: "AddProduct",
    };
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_all_products")
        .then((response) => {
          this.data = response.data;
          store.state.loading_state = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getData();
  },
  components: {
    AdminSidebar,
    TableComponent,
  },
};
</script>
